import { AlertType, PlannedOutageSeverity } from '@ge/models/constants';

export const PlannedOutageTemplate = {
  _id: '44aa2f2c-0bc4-4d43-b0c1-33dd25df23cc',
  alertType: AlertType.PLANNED_OUTAGE,
  entrypoint: 'string',
  sections: [
    {
      collapsed: false,
      hidden: false,
      metadata: {
        block: {
          position: {
            col: 1,
            row: 1,
            span: 12,
          },
          type: 'blockedActions',
          values: ['Block Cases', 'Block Commands'],
        },
        severity: {
          create: {
            hidden: false,
            readOnly: false,
            required: true,
          },
          edit: {
            hidden: false,
            readOnly: false,
            required: true,
          },
          defaultSelection: '',
          position: {
            col: 1,
            row: 4,
            span: 5,
          },
          type: 'select',
          values: Object.values(PlannedOutageSeverity).map((value) => ({
            label: value,
            value,
          })),
        },
        salesforceCase: {
          create: {
            hidden: false,
            readOnly: false,
            required: false,
          },
          edit: {
            hidden: false,
            readOnly: false,
            required: false,
          },
          position: {
            col: 1,
            row: 5,
            span: 12,
          },
          type: 'text',
        },
        contactInfo: {
          create: {
            hidden: false,
            readOnly: false,
            required: false,
          },
          edit: {
            hidden: false,
            readOnly: false,
            required: false,
          },
          position: {
            col: 1,
            row: 6,
            span: 12,
          },
          type: 'text',
        },
        estimatedEndDate: {
          create: {
            hidden: false,
            readOnly: false,
            required: false,
            validators: [
              {
                earliestDate: 'currentDate',
              },
            ],
          },
          edit: {
            hidden: false,
            readOnly: false,
            required: false,
            validators: [
              {
                earliestDate: 'currentDate',
              },
            ],
          },
          position: {
            col: 1,
            row: 3,
            span: 7,
          },
          type: 'dateTime',
        },
        requestedBy: {
          create: {
            hidden: false,
            readOnly: false,
            required: true,
          },
          edit: {
            hidden: false,
            readOnly: false,
            required: true,
          },
          position: {
            col: 1,
            row: 2,
            span: 5,
          },
          type: 'text',
        },
        requestedTime: {
          create: {
            hidden: false,
            readOnly: false,
            required: true,
            validators: [
              {
                earliestDate: 'currentDate',
              },
            ],
          },
          defaultSelection: 'currentDate',
          edit: {
            hidden: false,
            readOnly: false,
            required: true,
            validators: [
              {
                earliestDate: 'currentDate',
              },
            ],
          },
          position: {
            col: 1,
            row: 2,
            span: 7,
          },
          type: 'dateTime',
        },
      },
      type: 'body',
    },
    {
      collapsed: true,
      hidden: false,
      metadata: {
        description: {
          create: {
            readOnly: false,
            required: false,
          },
          edit: {
            readOnly: false,
            required: false,
          },
        },
      },
      type: 'description',
    },
    {
      collapsed: true,
      hidden: false,
      metadata: {
        sendNotification: {
          create: {
            readOnly: false,
            required: false,
          },
          edit: {
            readOnly: false,
            required: false,
          },
        },
      },
      type: 'send_notification',
    },
  ],
  operations: ['create', 'edit'],
  tenantId: 'dfsa',
};

export const PlannedOutageMailTemplate = {
  bcc: 'PlannedOutageBCC@mock.com',
  cc: 'PlannedOutageCC@mock.com',
  body: '',
  header: 'This is to inform of a Planned Outage for {{siteName}} – {{assetName}}',
  maxAttachments: 5,
  maxAttachmentSizeMb: 10,
  subject: 'Planned Outage Notifications for {{siteName}} – {{assetName}}',
  to: '',
};
